import React from 'react'
import { CsvPicker } from './CsvPicker'

//@ts-ignore
export const Uploader = ({ onChange, ...props }) => <CsvPicker onPick={(data) => onChange(data)} preview {...props} />
